// extracted by mini-css-extract-plugin
export var cartContainer = "_pn-4";
export var gray = "_pn-1";
export var itemContainer = "_pn-2";
export var itemDetails = "_pn-3";
export var strong = "_pn-0";